import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";

const IdleLogout = () => {
  const auth = useAuth();

  const { t } = useTranslation();

  const handleClickLogin = () => {
    auth.signinRedirect();
  };

  return (
    <Dialog
      open
      aria-labelledby="idle-dialog-title"
      aria-describedby="idle-dialog-description"
    >
      <DialogTitle id="idle-dialog-title">{t("idle_dialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="idle-dialog-description">
          {t("idle_dialog.message")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickLogin}>{t("idle_dialog.login")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleLogout;
